import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
// import './services/i18n'

ReactDOM.render(<App />, document.getElementById('root'))
